export default defineNuxtPlugin(async () => {
  const { $i18n } = useNuxtApp()
  const { app } = useWhitelabel()

  // Function to get saved locale from localStorage
  const getSavedLocale = () => {
    if (import.meta.client) {
      return localStorage.getItem('user-locale')
    }
    return null
  }

  // Function to save locale to localStorage
  const saveLocale = (locale: string) => {
    if (import.meta.client) {
      localStorage.setItem('user-locale', locale)
    }
  }

  // Function to update i18n messages with whitelabel values
  const updateWhitelabelMessages = () => {
    const currentLocale = $i18n.locale.value
    const messages = $i18n.getLocaleMessage(currentLocale)

    // Add whitelabel messages to the current locale
    const whitelabelMessages = {
      whitelabel: {
        app: {
          name: app.value.name
        }
      }
    }

    // Deep merge whitelabel messages into current locale messages
    const mergedMessages = { ...messages, ...whitelabelMessages }

    // Update the locale messages
    $i18n.setLocaleMessage(currentLocale, mergedMessages)
  }

  // On app initialization, check for saved locale or default to 'fa'
  if (import.meta.client) {
    const savedLocale = getSavedLocale()

    // If user has manually selected a locale before, use it
    if (savedLocale && (savedLocale === 'fa' || savedLocale === 'en')) {
      if (savedLocale !== $i18n.locale.value) {
        await $i18n.setLocale(savedLocale as 'fa' | 'en')
      }
    } else {
      // Always default to Persian if no saved preference
      if ($i18n.locale.value !== 'fa') {
        await $i18n.setLocale('fa')
      }
      saveLocale('fa')
    }
  }

  // Watch for locale changes and save them
  watch(() => $i18n.locale.value, (newLocale) => {
    if (newLocale) {
      saveLocale(newLocale)
      // Update whitelabel messages when locale changes
      nextTick(() => updateWhitelabelMessages())
    }
  })

  // Watch for whitelabel changes and update i18n messages
  watch(() => app.value, () => {
    updateWhitelabelMessages()
  }, { deep: true, immediate: true })

  return {
    provide: {
      saveLocale,
      updateWhitelabelMessages
    }
  }
})
